import {
  RF_FOR_SLICING_FAILED,
  RF_FOR_SLICING_REQUEST,
  RF_FOR_SLICING_SUCCESS,
} from "app/redux/actions/Factory/Peeling/rfForSlicing/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const rfForSlicingReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case RF_FOR_SLICING_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case RF_FOR_SLICING_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case RF_FOR_SLICING_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
